import React, { useState } from 'react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CheckIcon from '@mui/icons-material/Check';
import FilterListIcon from '@mui/icons-material/FilterList';

import {
  DropdownContainer,
  SortDisplay,
  SortText,
  DropdownListItem
} from './styles';
import { Box, Paper, ClickAwayListener } from '@mui/material';

export interface SortOption {
  id: string;
  label: string;
}

interface SortDropdownProps {
  options: SortOption[];
  activeSortId: string;
  onSortChange: (newId: string) => void;
}

const SortDropdown: React.FC<SortDropdownProps> = ({
  options,
  activeSortId,
  onSortChange,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const currentSort = options.find(opt => opt.id === activeSortId);
  const currentLabel = currentSort ? currentSort.label : 'Select Sort Option';

  const handleClick = () => {
    setIsOpen((prev) => !prev);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  const handleSelect = (id: string) => {
    onSortChange(id);
    handleClose();
  };

  return (
    <ClickAwayListener onClickAway={handleClose}>
      <Box sx={{ position: 'relative', display: 'block' }}>
        <DropdownContainer onClick={handleClick}>
          <SortDisplay>
            <FilterListIcon sx={{ color: 'primary.main', fontSize: 22 }} />
            <SortText>
              Sort By <strong>{currentLabel}</strong>
            </SortText>
          </SortDisplay>

          <ExpandMoreIcon
            sx={{ opacity: 0.7, fontSize: 22, color: 'text.secondary' }}
          />
        </DropdownContainer>

        {isOpen && (
          <Paper
            sx={{
              position: 'absolute',
              top: '100%',
              right: 0,
              left: 'auto',
              mt: 1,
              backgroundColor: 'background.paper',
              borderRadius: 2,
              boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
              minWidth: 250,
              zIndex: 1300,
              p: 1,
              transform: 'none !important', // Vital for zoom fix
            }}
          >
            {options.map(option => (
              <DropdownListItem
                key={option.id}
                onClick={() => handleSelect(option.id)}
                $isActive={option.id === activeSortId}
              >
                <span>{option.label}</span>
                {option.id === activeSortId && (
                  <CheckIcon sx={{ color: 'primary.main', fontSize: 20 }} />
                )}
              </DropdownListItem>
            ))}
          </Paper>
        )}
      </Box>
    </ClickAwayListener>
  );
};

export default SortDropdown;
